{
  "0c4364b5f1989d27": "¿Desea reintentar el pago de este turno?",
  "19766ed6ccb2f4a3": "Cancelar",
  "218c6f564365c23d": "Reintento de pago iniciado con éxito",
  "4967348989ea35bf": "Reintentar pago",
  "49e96d7cdf58069c": "Monto",
  "57b09b76d1bb7fac": "Hemos enviado su solicitud de reintento con éxito. Puede demorar unos minutos en procesarse y reflejarse aquí.",
  "5ad3dbd1242a4cea": "Entendido",
  "60e079d861dd6462": "Error al reintentar el pago",
  "99c40ab405926cb5": "Fecha",
  "aedeb39deae676eb": "Reintento de pago enviado",
  "e67e2941567ee80c": "Reintentar pago del turno",
  "ee0f0495791d4693": "ID de turno"
}
